import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';

import { HasPermissionDirective } from './directives/has-permission.directive';
import { AttendanceStopwatchComponent } from './components/attendance-stopwatch/attendance-stopwatch.component';
import { DatePickerComponent } from './components/date-picker/date-picker.component';
import { TimePickerComponent } from './components/time-picker/time-picker.component';
import { PaginationComponent } from './components/pagination/pagination.component';
import { CustomSelectComponent } from './components/custom-select/custom-select.component';
import { QuickAddSelectComponent } from './components/quick-add-select/quick-add-select.component';
import { DocAttachComponent } from './components/doc-attach/doc-attach.component';
import { EmptyStateComponent } from './components/empty-state/empty-state.component';
import { AvatarComponent } from './components/avatar/avatar.component';
import { PillComponent } from './components/pill/pill.component';
import { DataTableComponent } from './components/data-table/data-table.component';
import { TableColumnComponent } from './components/data-table/table-column.component';
import { ConfirmDialogComponent } from './components/confirm-dialog/confirm-dialog.component';
import { DrawerComponent } from './components/drawer/drawer.component';

@NgModule({
  imports: [
    CommonModule,
    RouterModule,
    FormsModule,
    ReactiveFormsModule,
    MatIconModule,
    MatButtonModule,
    MatTooltipModule,
    MatProgressSpinnerModule,
    AttendanceStopwatchComponent,
    DatePickerComponent,
    TimePickerComponent,
    PaginationComponent,
    CustomSelectComponent,
    QuickAddSelectComponent,
    DocAttachComponent,
    EmptyStateComponent,
    AvatarComponent,
    PillComponent,
    DataTableComponent,
    TableColumnComponent,
    DrawerComponent
  ],
  declarations: [
    HasPermissionDirective,
    ConfirmDialogComponent
  ],
  exports: [
    CommonModule,
    RouterModule,
    FormsModule,
    ReactiveFormsModule,
    HasPermissionDirective,
    ConfirmDialogComponent,
    AttendanceStopwatchComponent,
    DatePickerComponent,
    TimePickerComponent,
    PaginationComponent,
    CustomSelectComponent,
    QuickAddSelectComponent,
    DocAttachComponent,
    EmptyStateComponent,
    AvatarComponent,
    PillComponent,
    DataTableComponent,
    TableColumnComponent,
    DrawerComponent
  ]
})
export class SharedModule { }
